import { BehavioralAssessment } from "./BehavioralAssessment";
import { reportsSomewhatVeryOrExtremely } from "./reportsSomewhatVeryOrExtremely";

// Based on https://9amhealth.atlassian.net/browse/FEWEB-2238
// First non-null will be used
const assessmentSelectors: ((arg: {
  score: number;
  somewhatVeryOrExtremely?: boolean;
}) => BehavioralAssessment | null)[] = [
  ({ score }) => (score === 0 ? "allRight" : null),
  ({ score, somewhatVeryOrExtremely }) =>
    score > 0 && score < 5 && !somewhatVeryOrExtremely ? "allRight" : null,
  ({ score, somewhatVeryOrExtremely }) =>
    score > 0 && score < 5 && somewhatVeryOrExtremely ? "maybe" : null,
  ({ score, somewhatVeryOrExtremely }) =>
    score >= 5 && score < 10 && !somewhatVeryOrExtremely ? "maybe" : null,
  ({ score, somewhatVeryOrExtremely }) =>
    score >= 5 && score < 10 && somewhatVeryOrExtremely ? "recommend" : null,
  ({ score }) => (score >= 10 ? "recommend" : null)
];

export const getBehavioralAssessment = ({
  score,
  lastQuestionChoiceId
}: {
  score: number;
  lastQuestionChoiceId?: string;
}) => {
  const assessment = assessmentSelectors
    .map((selector) =>
      selector({
        score,
        somewhatVeryOrExtremely:
          reportsSomewhatVeryOrExtremely(lastQuestionChoiceId)
      })
    )
    .find((assessment) => assessment !== null);
  if (!assessment) {
    throw new Error("Couldn't assess behavior health questionnaire in Dialog");
  }
  return assessment;
};
